import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-document-folder-tree',
  templateUrl: './document-folder-tree.component.html',
  styleUrls: ['./document-folder-tree.component.scss'],
  imports: [CommonModule],
  standalone: true,
})
export class DocumentFolderTreeComponent {
  @Input() data?: any[];

  constructor(private common: CommonService) {}

  toggleFolder(item: any): void {
    if (item.children) {
      item.expanded = !item.expanded;
    }
  }

  handleItemClick(item: any): void {
    if (item.type === 'file') {
      if (this.common.getSelectedTemplate()) {
        this.common.getSelectedTemplate().isSelected = false;
      }

      item.isSelected = true;
      this.common.setSelectedTemplate(item);
    }
  }
}
